import { render, staticRenderFns } from "./AXSJK.vue?vue&type=template&id=c94e1e2e&scoped=true"
import script from "./AXSJK.vue?vue&type=script&lang=js"
export * from "./AXSJK.vue?vue&type=script&lang=js"
import style0 from "./AXSJK.vue?vue&type=style&index=0&id=c94e1e2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94e1e2e",
  null
  
)

export default component.exports